import { render, staticRenderFns } from "./LocaleText.vue?vue&type=template&id=37ad2fb8"
import script from "./LocaleText.vue?vue&type=script&lang=ts"
export * from "./LocaleText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports